<template>
  <div class="mytask">
    <!-- 查询 -->
    <!-- <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="题目名称:">
        <el-input v-model="formInline.user" placeholder="题目名称"></el-input>
      </el-form-item>
      <el-form-item label="发布老师:">
        <el-input v-model="formInline.user" placeholder="发布老师"></el-input>
      </el-form-item>
      <el-form-item label="类型:">
        <el-select v-model="formInline.region" placeholder="类型">
          <el-option label="所有" value="0"></el-option>
          <el-option label="铸造" value="-1"></el-option>
          <el-option label="卡环" value="2"></el-option>
          <el-option label="素描" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">查询</el-button>
      </el-form-item>
    </el-form> -->
    <!-- <el-table ref="filterTable" :data="tableData" style="width: 100%">
            <el-table-column prop="created_at" label="训练日期" sortable width="180" column-key="date">
            </el-table-column>
            <el-table-column prop="learn_id" label="训练项目" :formatter="formatterLearn">
            </el-table-column>
            <el-table-column prop="total_score" label="得分">
              <template slot-scope="scope">
                {{scope.row.total_score>=0?scope.row.total_score:'--'}}
              </template>
            </el-table-column>
            <el-table-column prop="total_time" label="用时" :formatter="formatter">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" v-if="scope.row.total_score>=0">查看
                </el-button>
                <el-button size="mini" disabled="disabled" @click="handleEdit(scope.$index, scope.row)" v-else>查看
                </el-button>
              </template>
            </el-table-column>
          </el-table> -->
    <ul class="taskList" v-loading="loading">
      <!-- 作业列表 -->
      <li class="taskItem" v-for="item in tabledata" :key="item.id">
        <span class="sign" v-show="item.cate.id==1">{{item.cate.name}}</span>
        <span class="sign kh" v-show="item.cate.id==2">{{item.cate.name}}</span>
        <span class="sign zz" v-show="item.cate.id==3">{{item.cate.name}}</span>
        <el-button type="primary" size="mini" class="btn" @click="submitbtn(item)" v-if="!item.status" :disabled="!item.statustime">提交</el-button>
        <!-- <el-button type="primary" size="mini" class="btn" @click="submitbtn">提交</el-button> -->
        <el-button type="info" size="mini" class="btn" @click="submitbtn(item.cate.url)" v-else>已提交</el-button>
        <div class="contents">
          <div class="firstdiv">
            <div class="taskname">{{item.title}}</div>
            <div class="teachername">发布老师：{{item.author}}</div>
            <div class="teachername">发布日期：{{item.start_time}}</div>
            <div class="teachername">截止日期：{{item.end_time}}</div>
          </div>
          <!-- 素描 -->
          <div class="twodiv">
            <div class="leftdiv">
              <div class="tit">题目描述:</div>
              <div class="condiv" v-html="item.description">

              </div>
            </div>
            <div class="leftdiv">
              <div class="tit">素描图片:</div>
              <div class="condiv">
               <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :limit="9"
            
              :on-success="handleInfoSuccess"
              :on-remove="handleInfoRemove"
              :file-list="ImgList"
              list-type="picture-card">
             <i class="el-icon-plus"></i>
            </el-upload>
              </div>
            </div>
          </div>
          <!-- 卡环 -->
          <div class="twodiv" v-show="false">
            <div class="leftdiv">
              <div class="tit">必做作业:</div>
              <div class="condiv">
                数据库萨克斯考试历时老师老师老师老师了数量老师老师放得开的
                了数量老师老师放得开的了数量老师老师放得开的
              </div>
            </div>
            <div class="leftdiv">
              <div class="tit">素描图片:</div>
              <div class="condiv">
                数据库萨克斯考试历时老师老师老师老师了数量老师老师放得开的
                了数量老师老师放得开的了数量老师老师放得开的
              </div>
            </div>
            <div class="leftdiv">
              <div class="tit"> 相关理解:</div>
              <div class="condiv">
                数据库萨克斯考试历时老师老师老师老师了数量老师老师放得开的
                了数量老师老师放得开的了数量老师老师放得开的
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div style="text-align: right">
      <el-pagination background @current-change="pageCurrentChange" :page-count="pageform.pages" :current-page="pageform.pageNum" layout="prev, pager, next" :total="pageform.total" :page-size='3'>
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      loading: true,
      uploadUrl: this.GLOBAL.BASE_URL + '/api/common/upload_file',
      dialogImageUrl: '',
      dialogVisible: false,
      textarea: '请输入理由',
      // 分页插件
      pageform: {
        total: 0,
        pages: 5,  // 总页数
        pageNum: 1, // 当前的页码
        pageSize: 3, // 每页显示条目个数
      },
      formInline: {
        user: '',
        region: ''
      },
      params: {
        class_id: this.$store.getters.getUserInfo.class_id,
        page_size: 3,
        page: 1,
        type: 1,
      },
      task_id: '',
      tabledata: '',
      timer: '',
      ImgList:[]
    };
  },
  computed: {

  },
  created() {
    this.gettasklist()
    var timer1 = setInterval(() => {
      var running = 0;

      for (var i = 0; i < this.tabledata.length; i++) {

        var nowdate = new Date().getTime()
        var enddate = new Date(this.tabledata[i].end_time).getTime();
        if (nowdate > enddate) {
          this.tabledata[i].statustime = true;
        } else {
          this.tabledata[i].statustime = false;
        }
        running = 1;
      }
      if (running) {
        this.tabledata = this.tabledata;
        this.$forceUpdate()//强制渲染
      }
    }, 1000);
    this.timer = timer1;
    // this.gettaskstatus(5)
  },
  methods: {

    //列表
    gettasklist() {
      this.$http.taskclass(this.params)
        .then(res => {
          if (res.code != 0) {
            this.loading = false;
            this.tabledata = res.data.task;
            this.pageform.pages = res.data.allPage;
            this.pageform.total = res.data.allCount;
            for (var i = 0; i < this.tabledata.length; i++) {
              var nowdate = new Date().getTime()
              var enddate = new Date(this.tabledata[i].end_time).getTime();
              if (nowdate > enddate) {
                this.tabledata[i].statustime = true;
              } else {
                this.tabledata[i].statustime = false;
              }
              this.gettaskstatus(this.tabledata[i])
            }
          } else {
            this.$message.error(res.message)
          }

        })
    },
    //作业状态
    gettaskstatus(item) {
      this.$http.taskstatus({ task_id: item.id })
        .then(res => {
          if (res.code == 200) {
            if (res.data) {
              item.status = true
            } else {
              item.status = false
            }
            console.log(this.tabledata)
          } else {

            this.$message.error(res.message)
          }

        })
    },
    //提交
    submitbtn(item) {
      var tooth = item.class_id;
      console.log(JSON.parse(tooth))
      return;
      if (url) {
        if (this.$cookies.get("token")) {
          // this.centerDialogVisible=true;
          // this.iframeSrc=url + '?user_id=' + this.$store.getters.getUserInfo.id
          // window.location.href=(url + '?user_id=' + this.$store.getters.getUserInfo.id);

          // return;
          var baseurl = this.GLOBAL.BASE_URL;
          window.location.href =
            url +
            "?user_id=" +
            this.$store.getters.getUserInfo.id +
            "+" +
            baseurl + "+" + this.code + "+" + this.$route.params.detailId;


        } else this.$router.push({ name: "Login" });
      } else this.$message("暂未开放");
      return;
      this.$confirm('确定要提交本次操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '提交成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消提交'
        });
      });

    },
    pageCurrentChange(val, e, form, jobExpLabel, pageform, searchVal) {
      this.pageform.pageNum = val;
      this.params.page = val;
      this.gettasklist();
    },
    // 产品详情 图片上传成功
    handleInfoSuccess(res, file, fileList) {
      this.ImgList.push(res.data)
      console.log(this.ImgList)
    },
    // 产品详情 图片删除成功
    handleInfoRemove(file, fileList) {
      var arr = this.ImgList;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == file.url) {
          this.ImgList.splice(i, 1);

          break;
        }
      }

    },


  },
  destroyed() {
    clearInterval(this.timer)
  }
};
</script>

<style  lang="less">
.mytask {
  .taskList {
    list-style: none;
    margin-bottom: 20px;

    .taskItem {
      position: relative;
      border: 1px solid #ebeef5;
      background-color: #fff;
      color: #303133;
      //   height: 200px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      margin-bottom: 20px;
      .sign {
        display: inline-block;
        position: absolute;
        top: 0;
        left: 0;
        width: 60px;
        line-height: 30px;
        height: 30px;
        background: #fd4e4e;
        color: #fff;
        font-size: 14px;
        text-align: center;
        border-radius: 0 0 10px 0;
      }
      .kh {
        background: #26ceaf;
      }
      .zz {
        background: #5b81ea;
      }
      .btn {
        position: absolute;
        top: 40px;
        right: 20px;
      }
      .contents {
        padding: 20px;
        padding-top: 40px;
      }
      .firstdiv {
        overflow: hidden;
        div {
          width: 25%;
        }
        .taskname {
          float: left;
          color: #5193f7;
          font-size: 16px;
          font-weight: bold;
        }
        .teachername {
          color: #303133;
          font-size: 16px;
          float: left;
        }
      }
      .twodiv {
        padding-top: 20px;
        overflow: hidden;
        .leftdiv {
          .tit {
            margin-bottom: 10px;
          }
          // width: 33.33%;
          width: 100%;
          float: left;
          .condiv {
            padding-right: 10px;
          }
        }
      }
    }
  }
  .el-upload--picture-card {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    line-height: 146px;
    vertical-align: top;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assessment/mytask.vue